import React from 'react';

import * as S from './styles';

type Props = {
  deletable?: boolean;
  onDelete?: () => void;
  children: React.ReactNode;
  iconName?: string | undefined;
  variant?: 'primary' | 'danger' | 'warning' | 'positive' | 'neutral';
  full?: boolean;
}

export const Tag = React.forwardRef<HTMLDivElement, Props>(({ deletable, children, ...props }: React.PropsWithChildren<Props>, forwardRef) => {

  return (
    <S.Container>
      <S.Tag
        {...props}
        ref={forwardRef}
        variant={props.variant || 'primary'}
        full={props.full}
      >
        {props.iconName &&
          <S.TagIcon icon={props.iconName} width={15} />
        }
        {children}
        {deletable &&
          <S.TagIcon icon='carbon:close-outline' width={15} />
        }
      </S.Tag>
    </S.Container>
  )
})